import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectorRef,
  Input,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { ENTER } from '@angular/cdk/keycodes';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from 'app/core/models/user.types';
import { UserService } from 'app/layout/common/user/user.service';
import { AccountService } from 'app/core';
import { ContactsService } from 'app/modules/contacts/contacts.service';
import { Contact } from 'app/modules/contacts/contacts.types';
import { MatLegacyChipInputEvent as MatChipInputEvent } from '@angular/material/legacy-chips';

@Component({
  selector: 'contact-sharing',
  templateUrl: './contact-sharing.component.html',
  styleUrls: ['./contact-sharing.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ContactSharingComponent implements OnInit {
  @Input() account: any;
  @Input() label: string;
  @Input() initialTags: string[] = [];
  @Input() showCCFields: boolean = false;
  @Output() onUpdateTags: EventEmitter<string[]> = new EventEmitter();
  @Output() onShowCopyField: EventEmitter<string> = new EventEmitter();
  private _unsubscribeAll: Subject<void>;
  public contactList: Contact[] = [];
  public commentForm: UntypedFormGroup;
  public editCommentForm: UntypedFormGroup;
  public user: User;
  public autocompleteCtrl: UntypedFormControl;
  public tags: string[] = [];
  separatorKeysCodes: number[] = [ENTER];
  removable = true;
  selectable = true;

  @ViewChild('contactInput')
  contactInput: ElementRef<HTMLInputElement>;

  /**
   * Constructor
   */
  constructor(
    private _contactsService: ContactsService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _activatedRoute: ActivatedRoute,
    private _formBuilder: UntypedFormBuilder,
    private _userService: UserService,
    private _accountService: AccountService,
  ) {
    this._unsubscribeAll = new Subject();

    this.autocompleteCtrl = new UntypedFormControl();

    this.autocompleteCtrl.valueChanges
      .pipe(filter(Boolean), takeUntil(this._unsubscribeAll), debounceTime(400), distinctUntilChanged())
      .subscribe((query: string) => {
        this._contactsService.getContacts(1, 20, 'first_name', 'asc', query).subscribe((response: any) => {
          this.contactList = response.contacts.filter((contact) => contact.email);
          this._changeDetectorRef.markForCheck();
        });
      });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit() {
    this._contactsService.accountId = this.account.id;

    if (this.initialTags && this.initialTags.length > 0) {
      for (let value of this.initialTags) {
        this.tags.push(value.trim());
      }
      this.onUpdateTags.emit(this.tags);
      this.autocompleteCtrl.setValue(null);
      this._changeDetectorRef.markForCheck();
    }
  }

  addTag(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.tags.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.onUpdateTags.emit(this.tags);
    this.autocompleteCtrl.setValue(null);
    this._changeDetectorRef.markForCheck();

    //this.contactForm.get('tag_list').patchValue(this.contact.tag_list);
  }

  removeTag(index): void {
    this.tags.splice(index, 1);
    this.onUpdateTags.emit(this.tags);
    this._changeDetectorRef.markForCheck();
    //this._value=this.tags;
  }

  selectContact(event): void {
    this.tags.push(event.option.id);
    this.onUpdateTags.emit(this.tags);
    this.autocompleteCtrl.setValue(null);
    this.contactInput.nativeElement.value = '';
    this._changeDetectorRef.markForCheck();
  }

  /**
   * Show the copy field with the given field name
   *
   * @param name
   */
  showCopyField(name: string): void {
    this.onShowCopyField.emit(name);
  }

  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {}
}
